// Web-sized copies of the originals in static/screenshots/
const screenshot = (name, caption) => ({
  src: `/screenshots/web/${name}.webp`,
  caption,
})

const screenshots = [
  screenshot("10-light-dashboard", "Dashboard: today, the week ahead and overdue clients"),
  screenshot("10-light-clients", "Client list"),
  screenshot("10-light-clients-filters", "Search and filter by any column"),
  screenshot("10-light-client-edit", "Client details"),
  screenshot("10-light-client-history", "Visit history for each client"),
  screenshot("10-light-visit-done", "Mark a visit done and plan the next one"),
  screenshot("10-light-calendar", "Calendar"),
  screenshot("10-light-settings", "Settings"),
  screenshot("10-light-about", "About"),
  screenshot("01-create-workspace", "Create a workspace"),
  screenshot("02-recovery-key", "Save your recovery key"),
  screenshot("03-setup-fields", "Choose the fields you track"),
  screenshot("04-csv-review", "Import clients from CSV or Excel"),
  screenshot("05-login-light", "Encrypted, password-protected login"),
  screenshot("20-dark-dashboard", "Dark mode: dashboard"),
  screenshot("20-dark-clients", "Dark mode: client list"),
  screenshot("20-dark-clients-filters", "Dark mode: search and filters"),
  screenshot("20-dark-client-edit", "Dark mode: client details"),
  screenshot("20-dark-client-history", "Dark mode: visit history"),
  screenshot("20-dark-visit-done", "Dark mode: mark a visit done"),
  screenshot("20-dark-calendar", "Dark mode: calendar"),
  screenshot("20-dark-settings", "Dark mode: settings"),
  screenshot("20-dark-about", "Dark mode: about"),
  screenshot("30-login-dark", "Dark mode: login"),
]

export default screenshots
